<mat-dialog-content>
  Coming Soon!
  <button mat-button (click)="btnClick()">Dismiss</button>
</mat-dialog-content>
<div class="clear"></div>
